import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import { TrackProvider } from "@/context/TrackContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import StageView from "@/pages/StageView";
import ModuleView from "@/pages/ModuleView";
import Library from "@/pages/Library";
import ScenarioList from "@/pages/ScenarioList";
import RolePlayChat from "@/pages/RolePlayChat";
import BranchingScenario from "@/pages/BranchingScenario";
import Admin from "@/pages/Admin";
import VerifyCertificate from "@/pages/VerifyCertificate";
import CallReview from "@/pages/CallReview";
import PracticeSimulator from "@/pages/PracticeSimulator";
import ObstacleTrainer from "@/pages/ObstacleTrainer";
import PressureScorer from "@/pages/PressureScorer";
import MyNotes from "@/pages/MyNotes";
import Commissions from "@/pages/Commissions";
import Shell from "@/components/Shell";

function Protected({ children, admin = false }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !["admin", "super_admin"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify" element={<VerifyCertificate />} />
      <Route path="/verify/:certId" element={<VerifyCertificate />} />
      <Route element={<Protected><Shell /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/stage/:stage" element={<StageView />} />
        <Route path="/module/:id" element={<ModuleView />} />
        <Route path="/library" element={<Library />} />
        <Route path="/notes" element={<MyNotes />} />
        <Route path="/commissions" element={<Commissions />} />
        <Route path="/scenarios" element={<ScenarioList />} />
        <Route path="/simulator" element={<PracticeSimulator />} />
        <Route path="/obstacle-trainer" element={<ObstacleTrainer />} />
        <Route path="/pressure-scorer" element={<PressureScorer />} />
        <Route path="/call-review" element={<CallReview />} />
        <Route path="/roleplay/:id" element={<RolePlayChat />} />
        <Route path="/branch/:id" element={<BranchingScenario />} />
        <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <WorkspaceProvider>
        <TrackProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </TrackProvider>
      </WorkspaceProvider>
    </AuthProvider>
  );
}
